import { Theme } from '@mui/material/styles';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

import { colorsPalette } from '../../../theme';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    button: {
      padding: 0,
      lineHeight: 1,
      fontWeight: 700,
      textDecoration: 'none',
      fontSize: 14,
      position: 'relative',
      color: theme.palette.primary.light,
      borderRadius: 0,
      transition: '0.1s ease all',
      display: 'flex',
      [theme.breakpoints.up('md')]: {
        fontSize: 16,
      },
      '&:hover': {
        background: 'transparent',
        '& $buttonLabel': {
          color: theme.palette.primary.light,
        },
      },
    },
    disabledBtn: {
      opacity: 0.1,
    },
    buttonLabel: {
      marginLeft: 6,
      color: colorsPalette.white,
    },
  }),
);

export default useStyles;
